import fetch from 'isomorphic-unfetch';

const createSupportMessage = async supportForm => {
  const res = await fetch('/api/support', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(supportForm)
  });
  return res;
};

const support = {
  createSupportMessage
};

export default support;
